module.exports = __webpack_public_path__ + "static/media/Waqas Ali and Zanib Butt- Decision and Order dated November21- 2024.ac823a12.pdf";